import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../../Components/ComponentButton';
import T from './Locale';
const SignupModalMarketing = ({ save, isLoading = false }) => {
    const [giveConsent, setGiveConsent] = useState();
    const selectMarketingConsent = (toggle) => {
        setGiveConsent(toggle);
        save(toggle);
    };
    return (_jsxs("div", { children: [_jsx("p", { children: T('partner.consent.content') }), _jsx("p", { children: _jsx("strong", { children: T('partner.consent.confirm') }) }), _jsx("br", {}), _jsx("br", {}), _jsxs("div", Object.assign({ className: 'text-center' }, { children: [_jsx(Button, { id: 'save_yes', title: T('partner.modal.yes'), classes: 'green', onClick: () => selectMarketingConsent(true), isLoading: isLoading && giveConsent }), _jsx(Button, { id: 'save_no', title: T('partner.modal.no'), classes: 'red', onClick: () => selectMarketingConsent(false), isLoading: isLoading && !giveConsent }), _jsx("br", {}), _jsx("a", Object.assign({ href: 'https://testaviva.dk/privatlivspolitik', target: '_blank', rel: 'noopener noreferrer' }, { children: T('partner.consent.conditions') }))] }))] }));
};
SignupModalMarketing.propTypes = {
    save: PropTypes.func.isRequired,
    isLoading: PropTypes.bool
};
export default SignupModalMarketing;
